module.exports = __webpack_public_path__ + "img/mydha.c9bdf074.png";